import type { AxiosError, AxiosResponse } from "axios";
import type {
  ChatNotificationApiItem,
  GetNotificationsInput,
  UpdateNotificationStatusInput,
} from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_NOTIFICATION_BASE_URL;

export const getAllNotifications = async ({
  resourceId,
  pageNumber,
  perPageCount,
}: GetNotificationsInput) => {
  try {
    const url = `${BASE_URL}/fetch/notifications/${resourceId}`;

    const response = await axiosClient.get(`${url}`, {
      params: { type: "resource", per_page: perPageCount, page: pageNumber },
    });
    const resData = response.data;

    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const updateNotificationStatus = async ({
  resourceId,
  notificationId,
}: UpdateNotificationStatusInput) => {
  try {
    const url = `${BASE_URL}/update/notification/seen/${resourceId}/${notificationId}`;
    // axiosClient.defaults.baseURL =
    //   import.meta.env["VITE_APP_NOTIFICATION_BASE_URL"];
    const response = await axiosClient.post(`${url}`);
    const resData = response.data;
    // axiosClient.defaults.baseURL = import.meta.env["VITE_APP_BASE_URL"];
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getAllChatNotifications = async ({
  resourceId,
  pageNumber,
  perPageCount,
}: GetNotificationsInput): Promise<ChatNotificationApiItem[]> => {
  try {
    const url = `${BASE_URL}/v2/fetch/chat/notifications/${resourceId}`;

    const response = await axiosClient.get(`${url}`, {
      params: {
        type: "resource",
        per_page: perPageCount,
        page: pageNumber,
      },
    });
    const resData = response.data;

    if (resData.success && resData.statusCode === 200) {
      return resData.result as ChatNotificationApiItem[];
    }
    throw response;
  } catch (error) {
    return apiErrorHandler(error as AxiosError | AxiosResponse);
  }
};

export const updateChatNotificationStatus = async ({
  resourceId,
  notificationId,
}: UpdateNotificationStatusInput) => {
  try {
    const url = `${BASE_URL}/update/chat/notification/seen/${resourceId}/${notificationId}`;
    // axiosClient.defaults.baseURL =
    //   import.meta.env["VITE_APP_NOTIFICATION_BASE_URL"];
    const response = await axiosClient.post(`${url}`);
    const resData = response.data;
    // axiosClient.defaults.baseURL = import.meta.env["VITE_APP_BASE_URL"];
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }

  // console.log(response.data);
};

export const clearAllNotifications = async (notificationType: string) => {
  try {
    const url = `${BASE_URL}/notifications/clear/${notificationType}`;

    const response = await axiosClient.delete(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const markAllNotificationsAsSeen = async (notificationType: string) => {
  try {
    const url = `${BASE_URL}/v1/notifications/see/${notificationType}`;
    const response = await axiosClient.patch(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
